
export const productGetters = {
  allFiles: function (state, getters) {
    console.log('getters all files')
    return state.files
  },
  signedUrlForUpload: function (state, getters) {
    return state.signedurls
  },
  signedUrlForDownload: function (state, getters) {
    return state.signedurls
  },
  getUserDetails: function (state) {
    return state.userid
  },
  getUserTaskDecision: function (state) {
    console.log('returning')
    console.log(state.usertaskdecision)
    return state.usertaskdecision
  },
  dropzoneConfig: function (state) {
    return state.dropzonedata
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js